import React, { useContext } from 'react';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ResourceType } from '../../../../types/resource';
import DeviationSidebarMosaic from '../../../_partials/DeviationSidebarMosaic';
import DeviationSidebarGrid from '../../../_partials/DeviationSidebarGrid';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './TopicBlock.scss';
const TopicBlock = ({ topicId, title, deviations, parentDeviation, linkTo })=>{
    const isMobile = useContext(MobileContext);
    const isResponsiveFyltGrid = useFlag('responsive_fylt_grid');
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionid: topicId,
            section_typeid: ResourceType.TOPIC
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['topic-header']
    }, /*#__PURE__*/ React.createElement(BiLink, {
        className: s['topic-link'],
        href: linkTo
    }, title)), isMobile && !isResponsiveFyltGrid ? /*#__PURE__*/ React.createElement(DeviationSidebarMosaic, {
        streamId: `devpage-sidebar-topics-${parentDeviation.deviationId}-${topicId}`,
        className: s['topic-grid'],
        parentDeviation: parentDeviation,
        deviations: deviations
    }) : /*#__PURE__*/ React.createElement(DeviationSidebarGrid, {
        streamId: `devpage-sidebar-topics-${parentDeviation.deviationId}-${topicId}`,
        className: s['topic-grid'],
        parentDeviation: parentDeviation,
        deviations: deviations,
        maxRows: 1
    })));
};
TopicBlock.displayName = 'TopicBlock';
export default TopicBlock;
